// GET routes
export const API_GET_BATCH_VOLUMES = 'api/conservation-burns/batch-volumes'
export const API_GET_BATCH_MEDIA = 'api/conservation-burns/batch-media'
export const API_GET_BATCH_BULK_DENSITY = 'api/conservation-burns/bulk-densities'
export const API_GET_QUENCH_TEAM_VIDEOS = 'api/conservation-burns/quench-team-videos'
export const API_GET_QUENCH_TEAM_VIDEOS_DATA = 'api/conservation-burns/quench-team-videos-data'
export const API_POST_QUENCH_TEAM_VIDEOS_DATA = 'api/conservation-burns/post-quench-team-videos-data'

export const API_GET_BIOCHAR_MASS = 'api/conservation-burns/biochar-mass'
export const API_GET_BATCH_CARBON_CONTENT = 'api/conservation-burns/batch-carbon-content'
export const API_GET_BIOCHAR_STORED_CARBON = 'api/conservation-burns/biochar-stored-carbon'
// DATA MONITORING ROUTES
// GET routes

export const API_GET_CB_BATCH_DATA = 'api/conservation-burns/batch-data'
export const API_GET_CB_ADDITIONAL_BATCH_DATA = 'api/conservation-burns/additional-batch-data'
export const API_GET_CB_FIELD_NOTES = 'api/conservation-burns/field-notes'

export const API_CB_IGNITION_FUEL = 'api/conservation-burns/ignition-fuel'

export const API_POST_CB_EQUIPMENT_TRANSPORT = 'api/conservation-burns/post-equipment-transport'
export const API_GET_CB_EQUIPMENT_TRANSPORT = 'api/conservation-burns/get-equipment-transport'

// POST routes
export const API_POST_QUENCH_TEAM_VIDEOS = 'api/conservation-burns/post-quench-team-videos'
export const API_POST_BATCH_CARBON_CONTENT = 'api/conservation-burns/post-batch-carbon-content'
export const API_POST_BIOCHAR_STORED_CARBON = 'api/conservation-burns/post-biochar-stored-carbon'

// S3 multipart upload (videos)
export const API_CB_VIDEO_MULTIPART_INIT = 'api/conservation-burns/videos/multipart/init'
export const API_CB_VIDEO_MULTIPART_PART_URL = 'api/conservation-burns/videos/multipart/part-url'
export const API_CB_VIDEO_MULTIPART_COMPLETE = 'api/conservation-burns/videos/multipart/complete'
export const API_CB_VIDEO_MULTIPART_ABORT = 'api/conservation-burns/videos/multipart/abort'